"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canUseWeakMap = typeof WeakMap === 'function' && !(typeof navigator === 'object' &&
    navigator.product === 'ReactNative');
//# sourceMappingURL=canUse.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/apollo-utilities/lib/util/canUse.js
// module id = +ZZP
// module chunks = 25